import ExemptionSection, { ExemptionSectionProps } from "../accommodation/ExemptionSection";
import { StepWrapper } from "./CommonStepComponents";

type AccommodationStepProps = ExemptionSectionProps;

export default function AccommodationStep(props: AccommodationStepProps) {
	return (
		<StepWrapper>
			<ExemptionSection {...props} />
		</StepWrapper>
	);
}
